export var ElementDefType;
(function (ElementDefType) {
    ElementDefType["BLOCK"] = "block";
    ElementDefType["FIELD"] = "field";
})(ElementDefType || (ElementDefType = {}));
//# sourceMappingURL=def.types.js.map